// removed by extract-text-webpack-plugin
module.exports = {"authorizationMobile":"AuthorizationMobile__authorizationMobile","title":"AuthorizationMobile__title","providerLogo":"AuthorizationMobile__providerLogo","mobile":"AuthorizationMobile__mobile","message":"AuthorizationMobile__message","button":"AuthorizationMobile__button","whyAuthorize":"AuthorizationMobile__whyAuthorize","growDotQello":"AuthorizationMobile__growDotQello","growDotBlue":"AuthorizationMobile__growDotBlue","growDotGolden":"AuthorizationMobile__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationMobile/AuthorizationMobile.scss
// module id = 1894
// module chunks = 0